import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import notificationSection from './sections/notification';
import newsPage from './pages/news';

init();
modalSection();
headerSection();
notificationSection();

newsPage();

let lastKnownScrollPosition = 0;
let ticking = false;
let topArrow = document.querySelector("#toTop");
let footerArrow = document.querySelector("#footerArrow")

topArrow.style.display = 'none';

if ($('#heroArrow').length > 0) {
    let heroArrow = document.querySelector("#heroArrow");
  }

  
  document.addEventListener("scroll", (event) => {
    lastKnownScrollPosition = window.scrollY;
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

  
    if (currentScroll > 2 ) {
  
      ticking = true;

    } 
    
    else if (currentScroll <= 0) {
        
        ticking = false;
    }

    if(ticking == true) {

        if ($('#heroArrow').length > 0) {  
            
            heroArrow.style.display = 'none';

            if(currentScroll <= 2 && currentScroll > 0 ) {

                heroArrow.classList.add("reveal-arrow-flip-down");
                //heroArrow.setAttribute('sw-reveal', 'arrow-flip-down');
            }
        }

        topArrow.style.display = 'block';

    } else if(ticking == false) {

        if ($('#heroArrow').length > 0) {  
            
            heroArrow.style.display = 'block';
        }

        topArrow.style.display = 'none';
    }

  });

 



// WEBPACK FOOTER //
// ./source/scripts/main.js